import React, { useState, useMemo, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import LS from '../../styles/layoutStyled';
import CS from '../../styles/componentStyled';
import styled from 'styled-components';
import {
  blankDefaultMsgRecoil,
  errorMsgRecoil,
  confirmMsgRecoil,
} from '../../atom/ModalAtom';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { adminAPI } from '../../api/axiosIndex';
import { SignInDto } from '../../model/user.dto';
import { Icon } from '../../component/Icon';

const AdminLogin = () => {
  const blankMsg = useRecoilValue(blankDefaultMsgRecoil);
  const setError = useSetRecoilState(errorMsgRecoil);
  const setConfirm = useSetRecoilState(confirmMsgRecoil);

  const navigate = useNavigate();

  const [id, setId] = useState('');
  const [password, setPassword] = useState('');

  const handleLogin = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (id.length === 0 || password.length === 0) {
      setError(blankMsg);
      return;
    }
    const dto: SignInDto = {
      passid: id,
      password: password,
    };

    try {
      const token = await adminAPI.adminSignIn(dto);

      sessionStorage.setItem('accessToken', token.data.accessToken);
      sessionStorage.setItem('refreshToken', token.data.refreshToken);
      sessionStorage.setItem(
        'accessExpire',
        (Date.now() + token.data.accessExpire * 1000).toString(),
      );
      sessionStorage.setItem(
        'refreshExpire',
        (Date.now() + token.data.refreshExpire * 1000).toString(),
      );

      navigate('/admin/userlist');
    } catch {
      setError('아이디가 올바르지 않거나\n비밀번호가 일치하지 않습니다.');
    }
  };

  useEffect(() => {
    localStorage.clear();
    sessionStorage.clear();
  }, []);

  return (
    <LoginWrap>
      <div>
        <div className="logo-box img-box">
          <Icon
            name="LogoManager"
            size="100%"
            color="#333333"
            color2="#777777"
          />
        </div>
        <form onSubmit={handleLogin}>
          <div className="input-wrap">
            <div className="input-box">
              <h3>아이디</h3>
              <input
                type="text"
                placeholder="아이디 입력"
                aria-label="아이디 입력 필드"
                value={id !== null ? id : ''}
                onChange={(e) => setId(e.target.value)}
              />
            </div>
            <div className="input-box">
              <h3>비밀번호</h3>
              <input
                type="password"
                placeholder="비밀번호 입력"
                aria-label="비밀번호 입력 필드"
                value={password !== null ? password : ''}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>
          <CS.Btn1Type1 type="submit">로그인</CS.Btn1Type1>
        </form>
      </div>
    </LoginWrap>
  );
};

export default AdminLogin;

export const LoginWrap = styled.div`
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;

  > div {
    width: 100%;
    max-width: 370px;
    box-sizing: border-box;
    padding: 0 20px;

    .logo-box {
      width: 100%;
      max-width: 220px;
      margin: 0 auto;
    }

    .input-wrap {
      margin-top: 40px;
      display: flex;
      flex-direction: column;
      gap: 12px;

      .input-box {
        h3 {
          font-weight: 700;
          font-size: 12px;
          color: #67717e;
          box-sizing: border-box;
          padding: 12px 0 0 16px;
        }

        input {
          box-sizing: border-box;
          padding: 12px 16px 16px 16px;
          border: none;
          border-bottom: 1px solid #f0f0f0;
          width: 100%;
          font-size: 16px;
          font-weight: 500;
          color: #333;
          &::placeholder {
            color: #737373;
          }
        }
      }
    }

    ${CS.Btn1Type1} {
      margin-top: 24px;
    }
  }
`;
